import { IcArrowTriangleFilled } from '@assets/icons/24x24';
import {
  Center,
  createListCollection,
  HStack,
  Icon,
  Menu,
  Portal,
  StackSeparator,
  Text,
  useSlotRecipe,
} from '@chakra-ui/react';
import { GPSCoordinatesListUnitSelectorProps } from '@components/ui/coordinatesInput/list/GPSCoordinatesList.slots';
import { useRef } from 'react';
import { useIntl } from 'react-intl';

import { CoordinatesUnit, CoordinatesUnitEnum } from '@/types/commons/commons.types';

export const UnitSelectorList = ({ unit, onUnitChange }: Readonly<GPSCoordinatesListUnitSelectorProps>) => {
  const { formatMessage } = useIntl();
  const recipe = useSlotRecipe({ key: 'menu' });
  const styles = recipe();
  const selectRef = useRef<HTMLSelectElement>(null);

  const unitCollection = createListCollection({
    items: Object.keys(CoordinatesUnitEnum).map((value) => ({
      value,
      label: formatMessage({ id: `common.units.${value}` }),
    })),
  });

  return (
    <Menu.Root>
      <Menu.Trigger className="group">
        <HStack gap={0} separator={<StackSeparator color="neutral.black" border="1px solid" />}>
          <Text paddingX={2} flex={1}>
            {unitCollection.items.find((u) => u.value === unit)?.label ?? 'Select'}
          </Text>
          <Center
            as="div"
            onMouseDown={(event) => {
              event.preventDefault(); // Prevents focus change (avoids input blur → touched)
            }}
            onClick={() => {
              selectRef.current?.focus();
            }}
            {...styles.triggerButton}
          >
            <Icon as={IcArrowTriangleFilled} color="white" />
          </Center>
        </HStack>
      </Menu.Trigger>

      <Portal>
        <Menu.Positioner>
          <Menu.Content>
            {unitCollection.items.map((unitOption) => {
              const isSelected = unitOption.value === unit;
              return (
                <Menu.Item
                  key={unitOption.value}
                  value={unitOption.value}
                  data-selected={isSelected}
                  onSelect={() => onUnitChange(unitOption.value as CoordinatesUnit)}
                >
                  {unitOption.label}
                </Menu.Item>
              );
            })}
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
};
